import { api } from "./http-client";
import {
  CharterDestination,
  CreateCharterDestinationDto,
  LocationOption,
  UpdateCharterDestinationDto,
} from "../interfaces/charter-destination.interface";

function buildFormData(dto: CreateCharterDestinationDto | UpdateCharterDestinationDto, thumbnail?: File | null): FormData {
  const fd = new FormData();
  Object.entries(dto).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      fd.append(key, String(value));
    }
  });
  if (thumbnail) {
    fd.append("thumbnail", thumbnail);
  }
  return fd;
}

export const charterDestinationsService = {
  listLocations: async (): Promise<LocationOption[]> => {
    const res = await api.request<LocationOption[]>({
      url: "/admin/charter-destinations/locations",
      method: "GET",
    });
    return (res.data as any).data ?? res.data;
  },

  list: async (page = 1, take = 20): Promise<{ data: CharterDestination[]; meta: any }> => {
    const res = await api.request<{ data: CharterDestination[]; meta: any }>({
      url: "/admin/charter-destinations",
      method: "GET",
      params: { page, take },
    });
    return res.data as any;
  },

  create: async (dto: CreateCharterDestinationDto, thumbnail?: File | null): Promise<CharterDestination> => {
    const res = await api.request<CharterDestination>({
      url: "/admin/charter-destinations",
      method: "POST",
      data: buildFormData(dto, thumbnail),
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  },

  update: async (id: string, dto: UpdateCharterDestinationDto, thumbnail?: File | null): Promise<CharterDestination> => {
    const res = await api.request<CharterDestination>({
      url: `/admin/charter-destinations/${id}`,
      method: "PUT",
      data: buildFormData(dto, thumbnail),
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  },

  remove: async (id: string): Promise<void> => {
    await api.request({ url: `/admin/charter-destinations/${id}`, method: "DELETE" });
  },
};
